<div mat-dialog-title class="cust-modal-title" style="    margin-bottom: 12px;
    padding-top: 12px;">
     <div class="prese_heading">
    <h2 class="m-0">Select country </h2>
  </div>
    <div class="prese_button">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
    </div>
  </div>
  <mat-dialog-content>
    
        <div class="row g-2 mb-3 justify-content-between phone-field">
          <!-- <mat-form-field appearance="outline" class="col-12">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country" required >
              <mat-select-trigger>
                +91
              </mat-select-trigger>
                <input
                style="width: 80%;
                height: 25px;
                padding: 10px;
                border: 1px solid lightgray;
                margin: 10px;
                border-radius: 5px;"                 
                  matInput
                  placeholder="Enter country name"
                />
              <mat-option
              >
             India
              </mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field appearance="outline" class="country-code">
            <mat-label>Country Code</mat-label>
            <mat-select
            [(ngModel)]="selectedCountryCode"
            required
            (selectionChange)="onCountrySelected($event)"
          >
            <mat-select-trigger>
              {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
              {{ "(" + selectedCountryCode.dial_code + ")" }}
            </mat-select-trigger>
            
            <mat-option>
              <ngx-mat-select-search
                noEntriesFoundLabel="no results found"
                name="countrysearch"
                placeholderLabel="Enter country name"
                [formControl]="searchString"
                (keyup)="onKey()"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let country of countryList" [value]="country">
              {{ country.flag }} {{ country.name }}
              {{ "(" + country.dial_code + ")" }}
            </mat-option>
          </mat-select>
          </mat-form-field>
          <div class="curr_heading">
            <h3 *ngIf="selectedCurrency">Currency: {{selectedCurrency.currency}} ({{selectedCurrency.currencySymbol}})</h3>
            <p>Choose the country where your business operates. This helps customize tax rates, regulations, and currency settings specific to your location. It ensures that your business complies with local laws and optimizes services accordingly.
            </p>
          </div>
        </div>
        <button
        (click)="goToBusinessCreate()"
        [disabled]="!selectedCurrency"
          mat-flat-button
          color="accent"
          id="first-form1"
          class="w-100 full-width1"
          #submitButton>
        Next
        </button>
      
  </mat-dialog-content>

  